import { render, staticRenderFns } from "./ConfigPopup.vue?vue&type=template&id=1e1d2475&scoped=true&"
import script from "./ConfigPopup.vue?vue&type=script&lang=ts&"
export * from "./ConfigPopup.vue?vue&type=script&lang=ts&"
import style0 from "./ConfigPopup.vue?vue&type=style&index=0&id=1e1d2475&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e1d2475",
  null
  
)

export default component.exports